import WS from "@adonisjs/websocket-client";

//TODO: code is repeating, clean this up once everything is done
export default {
  namespaced: true,
  // STATE
  state: () => ({
    ws: null,
    uid: null,
    import_progress: 0,
    ebay_progress: 0,
    shopify_progress: 0,
    etsy_progress: 0,
    batch_print_progress: 0,
    update_progress: 0,
  }),
  // GETTERS
  getters: {
    getImportSubscription(state) {
      return state.ws.getSubscription(`import:${state.uid}`);
    },
    getEbaySubscription(state) {
      return state.ws.getSubscription(`ebay:${state.uid}`);
    },
    getEtsySubscription(state) {
      return state.ws.getSubscription(`etsy:${state.uid}`);
    },
    getShopifySubscription (state) {
      return state.ws.getSubscription(`shopify:${state.uid}`);
    },
    getBatchPrintSubscription(state) {
      return state.ws.getSubscription(`batchPrint:${state.uid}`);
    },
    getUpdateSubscription(state) {
      return state.ws.getSubscription(`update:${state.uid}`);
    },
    getWS(state) {
      if(!state.ws) throw new Error("WS not set yet");
      return state.ws;
    },
    getImportProgress(state){
      let progress_label = "";
      if(state.import_progress <= 80 ){
        progress_label = "Processing records, getting rates";
      }else if(state.import_progress > 80) {
        progress_label = "Finalizing";
      }
      return {
        value: state.import_progress,
        label: progress_label
      }
    },
    getEtsyProgress(state){
      let progress_label = "";
      if(state.etsy_progress < 20 ){
        progress_label = "Initializing"
      }else if(state.etsy_progress < 89) {
        progress_label = "Filtering Etsy orders that are ready to ship";
      } else if(state.etsy_progress < 91){
        progress_label = "Computing Rates";
      }else if (state.etsy_progress > 90) {
        progress_label = "Finalizing";
      }
      return {
        value: state.etsy_progress,
        label: progress_label
      }
    },
    getEbayProgress(state){
      let progress_label = "";
      if(state.ebay_progress < 20 ){
        progress_label = "Initializing"
      }else if(state.ebay_progress < 89) {
        progress_label = "Filtering last 14 days of eBay orders that are ready to ship";
      } else if(state.ebay_progress < 91){
        progress_label = "Computing Rates";
      }else if (state.ebay_progress > 90) {
        progress_label = "Finalizing";
      }
      return {
        value: state.ebay_progress,
        label: progress_label
      }
    },
    getShopifyProgress(state){
      let progress_label = "";
      if(state.shopify_progress < 11 ){
        progress_label = "Initializing"
      }else if(state.shopify_progress < 81) {
        progress_label = "Filtering last 60 days of shopify orders that are ready to ship";
      } else if(state.shopify_progress < 91){
        progress_label = "Processing Rates";
      }else if (state.shopify_progress > 90) {
        progress_label = "Finalizing";
      }
      return {
        value: state.shopify_progress,
        label: progress_label
      }
    },
    getBatchPrintProgress(state){
      let progress_label = "";
      if(state.batch_print_progress < 11 ){
        progress_label = "Initializing";
      } else if(state.batch_print_progress < 90 ){
        progress_label = "Processing Request";
      }else {
        progress_label = "Finalizing";
      }
      return {
        value: state.batch_print_progress,
        label: progress_label
      }
    },
    getUpdateProgress(state){
      let progress_label = "";
      if(state.update_progress <= 80 ){
        progress_label = "Processing records, getting rates";
      }else if(state.update_progress > 80) {
        progress_label = "Finalizing";
      }
      return {
        value: state.update_progress,
        label: progress_label
      }
    },
  },
  // MUTATION
  mutations: {
    setWS(state, ws){
      state.ws = ws;
    },
    setUID(state, uid){
      state.uid = uid
    },
    setImportProgress(state, progress){
      console.log("import", progress);
      if(progress == null){
        state.import_progress = 0;
      } else{
        state.import_progress += progress
      }
    },
    setEbayProgress(state, progress){
      if(progress == null){
        state.ebay_progress = 0;
      } else{
        state.ebay_progress += progress
      }
    },
    setEtsyProgress(state, progress){
      if(progress == null){
        state.etsy_progress = 0;
      } else{
        state.etsy_progress += progress
      }
    },
    setShopifyProgress(state, progress){
      if(progress == null){
        state.shopify_progress = 0;
      } else{
        state.shopify_progress += progress
      }
    },
    setBatchPrintProgress(state, progress){
      if(progress == null){
        state.batch_print_progress = 0;
      } else{
        state.batch_print_progress += progress
      }
    },
    setUpdateProgress(state, progress){
      if(progress == null){
        state.update_progress = 0;
      } else{
        state.update_progress += progress
      }
    },
  },
  // ACTIONS
  actions: {
    async connect ({commit, dispatch, state}) {
      // console.log("connecting to ws")
      if(!state.ws){
        console.log("SETTING WS")
        const wsURL = `${process.env.MIX_WS}`;
        const ws = WS(wsURL, { path: "ws" });
        ws.connect();
        commit("setWS", ws);
        ws.on("open", () => { console.log("ws open"); });
        ws.on("error", (e) => { console.error("Unable to connect to ws"); });
      }
    },
    async subscribe({dispatch,commit, state}, uid){
      // no user yet, meaning no subscription made yet
      if(state.ws && !state.uid){
        commit("setUID", uid);
        await Promise.all([
          dispatch("subscribeTo", "ETSY"),
          dispatch("subscribeTo", "EBAY"),
          dispatch("subscribeTo", "SHOPIFY"),
          dispatch("subscribeTo", "BATCH"),
          dispatch("subscribeTo", "IMPORT"),
          dispatch("subscribeTo", "UPDATE"),
        ]);
      }
    },
    async subscribeTo({commit, dispatch, state}, kind = null) {
      if(kind){
        switch(kind){
          case "IMPORT":
            const importChan = state.ws.subscribe(`import:${state.uid}`);
            console.log("import channel ", importChan);
            importChan.on("progress", async (p) => {
              commit("setImportProgress", p)
            })
            importChan.on("done", async (p) => {
              commit("setImportProgress", null)
              dispatch('refreshNotification', null, {root: true})
            });

            importChan.on("error", async () => {
              console.error("UNABLE TO PROCESS IMPORT");
            });
            break;
          case "EBAY":
            const ebayChan = state.ws.subscribe(`ebay:${state.uid}`);
            console.log("ebay channel ", ebayChan);
            ebayChan.on("sync", async (p) => {
              commit("setEbayProgress", p)
            });
            ebayChan.on("ebay_sync_done", async () => {
              commit("setEbayProgress", null)
            });
            ebayChan.on("ebay_error", (error) => {
              console.error("ebay_error: ", error);
              commit("setEbayProgress", null)
            });
            break;
          case "ETSY":
            const etsyChan = state.ws.subscribe(`etsy:${state.uid}`);
            console.log("etsy channel ", etsyChan);
            etsyChan.on("sync", async (p) => {
              console.log("etsy sync", p);
              commit("setEtsyProgress", p)
            });
            etsyChan.on("etsy_sync_done", async () => {
              console.log("etsy sync done");
              commit("setEtsyProgress", null)
            });
            etsyChan.on("etsy_error", (error) => {
              console.error("etsy_error: ", error);
              commit("setEtsyProgress", null)
            });
            break;
          case "SHOPIFY":
            const shopifyChan = state.ws.subscribe(`shopify:${state.uid}`);
            shopifyChan.on("sync", async (p) => {
              console.log(p)
              commit("setShopifyProgress", p)
            });
            shopifyChan.on("shopify_sync_done", async () => {
              commit("setShopifyProgress", null)
            });
            shopifyChan.on("shopify_error", (error) => {
              console.error("shopify_error: ", error);
              commit("setShopifyProgress", null)
            });
            break;
          case "BATCH":
            const batchPrintChan = state.ws.subscribe(`batchPrint:${state.uid}`);
            batchPrintChan.on("progress", async (p) => {
              commit("setBatchPrintProgress", p)
            });
            batchPrintChan.on("batch_data", async({ base64 }) => {
              // feed label to printer
              if(base64 !== null){
                console.log("with base64, printing label");
                dispatch("addPrintJob", {
                  label: base64
                }, {root: true});
              }
            });
            batchPrintChan.on("batch_print_done", (d)=>{
              commit("setBatchPrintProgress", null)
              dispatch('refreshNotification', null, {root: true})
            });
            batchPrintChan.on("batch_error", async(data) => {
              console.error('batch error', data);
              commit("setBatchPrintProgress", null)
            })
            break;
          case "UPDATE":
            const updateChan = state.ws.subscribe(`update:${state.uid}`);
            console.log("update channel ", updateChan);
            updateChan.on("progress", async (p) => {
              commit("setUpdateProgress", p)
            })
            updateChan.on("done", async (p) => {
              commit("setUpdateProgress", null)
              dispatch('refreshNotification', null, {root: true})
            });

            updateChan.on("error", async (e) => {
              console.error("UNABLE TO PROCESS UPDATE", e);
            });
            break;
        }
      }
    },
  },

}



// WEBPACK FOOTER //
// ./resources/assets/js/store/ws.js